import React,{useState} from 'react';
//import TeamMemberDetail from './TeamMemberDetail';
//import styles from './Teams.module.sass'

const Team = () => {

    const teamMembers = [
        {
              //image:'./images/people/Brian-Massie3.png'
              //image:'./images/people/Brian-new.jpg'
              id: 1
            //, image:'./images/people/Brian-new_719x720.jpg'
            , image:'./images/people/RealSplit-Team-Brian-Massie.jpg'
            , name: 'Brian Massie'
            , position: 'Co-Founder | CEO'
        }
        , {
              id: 2
            //, image:'./images/people/Daniel-Sloan.jpg'
            //, image:'./images/people/Daniel-new.jpg'
            //, image:'./images/people/Daniel-new_600x600.jpg'
            , image:'./images/people/RealSplit-Team-Daniel-Sloan.jpg'
            , name: 'Daniel Sloan'
            , position:'Co-Founder | President'
        }
        , {
              id: 3
            //, image:'./images/people/Dermot-Doherty0F.png'
            //, image:'./images/people/Dermot-new_300x300.jpg'
            , image:'./images/people/RealSplit-Team-Dermot-Doherty.jpg'
            , name: 'Dermot Doherty'
            , position: 'CTO | Software Architect'
        }
    ];

    const advisors = [
        /*
        {
              id: 4
            , image:'./images/people/Mateo-Stroul.jpg'
            , name: 'Mateo Stroul'
            , position: 'Technology Advisor | Solutions Architect'
        }
        {
              id: 4
            , image:'./images/people/Raj-Kapoor.jpg'
            , name: 'Raj Kapoor'
            , position: 'Advisor'
        }
        */
        {
              id: 5
            , image:'./images/people/Sanjeev-Lalchandani.jpg'
            , name: 'Sanjeev Lalchandani'
            , position: 'Technology Advisor'
        }
        , {
              id: 6
            , name: 'Brian Baker'
            , image:'./images/people/Brian-Baker.jpg'
            , position: 'Advisor'
        }
        , {
              id: 7
            , name: 'Ryan Granito'
            , image:'./images/people/Ryan-Granito.jpg'
            , position: 'Advisor'
        }
        , {
              id: 8
            , name: 'Dylan Marer'
            , image:'./images/people/Dylan-Marer.jpg'
            , position: 'Advisor'
        }
        , {
              id: 9
            , name: 'Joshua Whittemore'
            , image:'./images/people/Joshua-Whittemore.jpg'
            , position: 'Advisor'
        }
        /*
        , {
              image:'./images/people/team-member6.jpg'
            , name: 'Phil Appleseed'
            , position:'Position in the company'
        }
        */
    ];

    const [open, setOpen] = useState(false);
    const [data, setData] = useState(null);

    const onTeamMemberClick = (each) => {
        console.log('onTeamMemberClick(): each = ', each);
        setOpen(true);
        setData(each);
    }

    let keyWeirdness = 100;

    return (

        <section
            //className={styles.teamsection}
            //id="teams"
            //className = 'max-width'
            className = 'sensei sensei-white'
            >

            <div
                id = 'team-wrapper'
                className = 'max-width'
                >

                {/*
                <TeamMemberDetail open={open} setOpen={setOpen} teamMemberData={data} />
                */}

                <div
                    //className = 'table'
                    className = 'flex-box section-header max-width'
                    //style = {{
                    //    margin: 'auto'
                    //    , justifyContent: 'center'
                    //}}
                    >

                    {/*
                    <div className = 'row'>
                    */}
                        <div
                            //className = 'cell'
                            className = 'flex-item section-header-left'
                            //style = {{
                            //    verticalAlign: 'middle'
                            //    , width: '120px'
                            //    , textAlign: 'left'
                                //, marginLeft: 'auto'
                                //, marginRight: 'auto'
                            //}}
                            >
                            <img
                                className = 'realsplit-logo'
                                src = 'images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                //style = {{
                                //    maxHeight: '60px'
                                    //, verticalAlign: 'middle'
                                    //, maxWidth: '50px'
                                //}}
                                />
                        </div>

                        <div
                            //className = 'cell'
                            className = 'flex-item'
                            //style = {{
                            //    padding: '0px 50px'
                            //}}
                            >
                            <h2
                                //className = { styles.sectionTitle }
                                style = {{
                                    padding: '50px 0px 20px 0px'
                                    , margin: '0'
                                    //, fontSize: 'unset'
                                    , whiteSpace: 'nowrap'
                                }}
                                >Team</h2>
                        </div>

                        <div
                            //className = 'cell'
                            className = 'flex-item section-header-right'
                            //style = {{
                            //    verticalAlign: 'middle'
                            //    , width: '120px'
                            //    , textAlign: 'right'
                                //, marginLeft: 'auto'
                                //, marginRight: 'auto'
                            //}}
                            >
                            <img
                                className = 'realsplit-logo'
                                src = 'images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                //style = {{
                                //    maxHeight: '60px'
                                    //, maxWidth: '50px'
                                //}}
                                />
                        </div>
                    {/*
                    </div>
                    */}
                </div>

                <p
                    style = {{
                          maxWidth: '700px'
                        , fontFamily: 'Source Sans 3'
                        //, fontSize: '20px'
                        , fontStyle: 'normal'
                        //, fontWeight: '400'
                        //, lineHeight: '150%'
                        , color: 'var(--color-gray-600, #343A40)'
                        , textAlign: 'center'
                        , margin: 'auto'
                        , paddingBottom: '40px'
                    }}
                    >Meet our dedicated team: a blend of seasoned real estate professionals and innovative thinkers, all passionate about redefining property investment. With decades of combined experience, we're committed to delivering exceptional value, ensuring our clients' goals align with the best opportunities. Trust in our expertise to guide your investment journey.</p>

                <h2
                    //className = { styles.sectionTitle }
                    style = {{
                        padding: '0px 0px 40px 0px'
                        , margin: '0'
                        //, fontSize: 'unset'
                    }}
                    >Management Team</h2>

                <div
                    className = 'container team-container max-width'
                    style = {{
                          display: 'flex'
                        , flexWrap: 'wrap'
                        //, flexGrow: '1'
                        , gap: '24px'
                        //, justifyContent: 'space-around'
                        , justifyContent: 'space-evenly'
                        //, width: 'calc(100% / 3)'
                    }}>

                    {
                        teamMembers.map((dataItem, teamMembersIndex) =>

                                <div
                                    key = { dataItem.id }
                                    dataitem = { dataItem.id }
                                    //className = 'team-item'
                                    style = {{
                                        //margin: 'auto'
                                        textAlign: 'center'
                                        //, border: 'blue 2px solid'
                                    }}>
                                    <div
                                        className = 'team-item'
                                        style = {{
                                            //width: 'calc(100% / 3)'
                                            margin: 'auto'
                                            //, backgroundColor: '#fff'
                                            , maxWidth: '325px'
                                            //, width: '33%'
                                            //, flexGrow: '1'
                                            //, flexGrow: 'unset'
                                            //, flexBasis: '33%'
                                            //, flexBasis: 'calc(33% - 24px)'
                                            //, padding: '0px 12px'
                                            //, flexGrow: '1'
                                        }}
                                        onClick = { () => onTeamMemberClick(dataItem) }
                                        >

                                        <div
                                            style = {{
                                                  textAlign: 'center'
                                                //, maxWidth: '200px'
                                                , width: '200px'
                                                //, maxHeight: '200px'
                                                , height: '200px'
                                                , overflow: 'hidden'
                                                //, backgroundColor: '#000'
                                                , marginLeft: 'auto'
                                                , marginRight: 'auto'
                                                //, width: '200px'
                                                //, height: '200px'
                                                , borderRadius: '50%'
                                            }}>

                                            <img src = { dataItem.image }
                                                style = {{
                                                    //width: 'calc(100% / 3)'
                                                      //width: '100%'
                                                      //width: 'auto'
                                                    //, maxWidth: '250px'
                                                    //, height: 'auto'
                                                    height: '100%'
                                                    , width: 'auto'
                                                    //, minHeight: '325px'
                                                    //, maxHeight: '400px'
                                                    //, maxHeight: '325px'
                                                }} />
                                        </div>

                                        <div className = "title">

                                            <h3
                                                style = {{
                                                    /*
                                                    , fontFamily: 'Source Sans 3'
                                                    , padding: '20px 0px'
                                                    , fontSize: '30px'
                                                    , fontStyle: 'normal'
                                                    , fontWeight: '700'
                                                    , lineHeight: '100%'
                                                    , color: 'var(--color-gray-900, #212529)'
                                                    */
                                                      textAlign: 'center'
                                                    , whiteSpace: 'nowrap'
                                                    , textOverflow: 'ellipsis'
                                                    , overflow: 'hidden'
                                                    //, fontSize: '26px'
                                                }}
                                                >
                                                { dataItem.name }
                                            </h3>

                                            <p
                                                /*
                                                style = {{
                                                      fontFamily: 'Source Sans 3'
                                                    , fontSize: '15px'
                                                    , fontStyle: 'normal'
                                                    , fontWeight: '400'
                                                    , lineHeight: '150%'
                                                    , textAlign: 'center'
                                                    , color: 'color: var(--color-gray-900, #212529)'
                                                }}
                                                */
                                                >
                                                { dataItem.position }
                                            </p>

                                        </div>

                                    </div>
                                </div>
                                
                        )
                    }

                </div>

                <h2
                    //className = { styles.sectionTitle }
                    style = {{
                        padding: '50px 0px 40px 0px'
                        , margin: '0'
                        //, fontSize: 'unset'
                    }}
                    >Advisors</h2>

                <div
                    className = 'container team-container max-width'
                    style = {{
                          display: 'flex'
                        , flexWrap: 'wrap'
                        //, flexGrow: '1'
                        , gap: '24px'
                        //, justifyContent: 'space-around'
                        , justifyContent: 'space-evenly'
                        //, width: 'calc(100% / 3)'
                    }}>

                    {
                        advisors.map((advisor, advisorsIndex) =>

                                <div
                                    key = { advisor.id }
                                    dataitem = { advisor.id }
                                    //className = 'team-item'
                                    style = {{
                                        //margin: 'auto'
                                        textAlign: 'center'
                                        //, border: 'blue 2px solid'
                                    }}>
                                    <div
                                        //key = { 'test_' + index2 }
                                        className = 'team-item'
                                        style = {{
                                            //width: 'calc(100% / 3)'
                                            margin: 'auto'
                                            //, backgroundColor: '#fff'
                                            , maxWidth: '325px'
                                            //, width: '33%'
                                            //, flexGrow: '1'
                                            //, flexGrow: 'unset'
                                            //, flexBasis: '33%'
                                            //, flexBasis: 'calc(33% - 24px)'
                                            //, padding: '0px 12px'
                                            //, flexGrow: '1'
                                        }}
                                        onClick = { () => onTeamMemberClick(advisor) }
                                        >

                                        <div
                                            style = {{
                                                  textAlign: 'center'
                                                //, maxWidth: '325px'
                                                //, maxHeight: '325px'
                                                , overflow: 'hidden'
                                                //, backgroundColor: '#000'
                                                , marginLeft: 'auto'
                                                , marginRight: 'auto'
                                                , width: '200px'
                                                , height: '200px'
                                                , borderRadius: '50%'
                                            }}>

                                            <img src = { advisor.image }
                                                style = {{
                                                    //width: 'calc(100% / 3)'
                                                      width: '100%'
                                                      //width: 'auto'
                                                    //, maxWidth: '325px'
                                                    //, minHeight: '325px'
                                                    //, maxHeight: '400px'
                                                    //, maxHeight: '325px'
                                                }} />
                                        </div>

                                        <div className = "title">

                                        <h3
                                            style = {{
                                                /*
                                                , fontFamily: 'Source Sans 3'
                                                , padding: '20px 0px'
                                                , fontSize: '30px'
                                                , fontStyle: 'normal'
                                                , fontWeight: '700'
                                                , lineHeight: '100%'
                                                , color: 'var(--color-gray-900, #212529)'
                                                */

                                                textAlign: 'center'
                                                //, fontSize: '26px'
                                                //, whiteSpace: 'nowrap'
                                                //, textOverflow: 'ellipsis'
                                                //, textAlign: 'left'
                                                //, overflow: 'hidden'
                                            }}
                                            >
                                            { advisor.name }
                                        </h3>

                                        <p
                                            /*
                                            style = {{
                                                  fontFamily: 'Source Sans 3'
                                                , fontSize: '15px'
                                                , fontStyle: 'normal'
                                                , fontWeight: '400'
                                                , lineHeight: '150%'
                                                //, textAlign: 'left'
                                                , textAlign: 'center'
                                                , color: 'color: var(--color-gray-900, #212529)'
                                            }}
                                            */
                                            >
                                                { advisor.position }
                                            </p>

                                        </div>

                                    </div>

                                </div>

                        )
                    }

                </div>

            </div>
        </section>
    );
}

export default Team;
